export default block =>
  import(`../../${block.name.split('/')[1].replace('--', '/')}`);
